/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendSubscriptionDto } from '../../models/backend-subscription-dto';
import { BackendSubscriptionRequestDto } from '../../models/backend-subscription-request-dto';

export interface SubscriptionActiveUpdate$Params {
  body?: BackendSubscriptionRequestDto;
}

export function subscriptionActiveUpdate(
  http: HttpClient,
  rootUrl: string,
  params?: SubscriptionActiveUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendSubscriptionDto>> {
  const rb = new RequestBuilder(rootUrl, subscriptionActiveUpdate.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendSubscriptionDto>;
    }),
  );
}

subscriptionActiveUpdate.PATH = '/api/subscription/active/';
